<div class="twc-ml-3 twc-mt-2 twc-mb-3">
    <div *ngIf="label">
        <span class="twc-body"> {{ label | translate }} </span>
    </div>
    <input class="input-name" *ngIf="property.type === 'CharField' || property.field === 'name'" twcInput type="text"
        [(ngModel)]="property.value" name="{{property.field | translate}}" placeholder="{{ label | translate }}"
        [readonly]="!property.editable()" (ngModelChange)="onChange()" />

    <textarea twcTextarea *ngIf="property.type !== 'CharField' && property.field !== 'name'"
        [(ngModel)]="property.value" name="{{property.field | translate}}" placeholder="{{ label | translate }}"
        [readonly]="!property.editable()" (ngModelChange)="onChange()" rows="1"></textarea>
</div>
